export default __webpack_public_path__ + "static/media/coins.ee13f706.png";